// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link, Redirect } from "react-router-dom";
import styled from "../common/styled";
import * as actions from "../actions";
import { compose } from "../common/utils";
import { authUser, signOut, s3Upload } from "../common/aws_lib";
import {
  Button,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  ButtonGroup,
  Input
} from "reactstrap";
import PhotoForm from "../components/PhotoForm";
import PhotoMultiForm from "../components/PhotoMultiForm";
import SettingsForm from "../components/SettingsForm";
import CopyForm from "../components/CopyForm";
import * as API from "../common/api";
//import { remote, nativeImage } from 'electron';
import fs from "fs";
import path from "path";
import { toast } from "react-toastify";
import { config } from "../config";

const { Text, Image, View } = styled.plain;

function getFilesizeInBytes(f) {
  const stats = fs.statSync(f);
  return stats.size;
}

class HomePage extends React.Component {
  state = {
    isLogined: null,
    showPhotoForm: false,
    photoFormConfig: {},
    showSettingsForm: false,
    showCopyForm: false,
    mode: "TAGGED",
    currentPhoto: {},
    selectedPhotos: [],
    showPhotoMultiForm: false,
    copiedPhoto: {},
    copiedAttrs: {}
  };

  componentDidMount() {
    this.setInitialHeader();

    authUser()
      .then(isLogined => {
        this.setState({ isLogined });
        if (isLogined) {
          this.loadData(this.state.mode);
        } else {
          this.props.history.push("/login");
        }
        return isLogined;
      })
      .catch(() => {
        this.setState({ isLogined: false });
      });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.gallery &&
      nextProps.gallery.Items &&
      nextProps.gallery.Items.length > 0 &&
      nextProps.gallery.Items !== this.props.gallery.Items
    ) {
      if (this.state.openFirst) {
        this.setState({ openFirst: false });
        this.onPhotoFormOpen(nextProps.gallery.Items[0], 0);
      }
    }
  }

  setInitialHeader() {
    this.props.setHeader((restore, header) => ({
      title: "",
      right: "",
      left: ""
    }));
  }

  setMode = mode => {
    this.setState({ mode });
    this.loadData(mode);
  };

  loadData = mode => {
    if (mode === "TAGGED") {
      this.props.loadGallery();
    } else {
      this.props.loadUntagged();
    }
    this.setState({ selectedPhotos: [] });
  };

  onLogout = () => {
    signOut();
    this.props.clearAppData();
    this.props.history.push("/login");
  };

  hello = () =>
    API.Hello().then(
      result => {
        console.log(result);
      },
      e => {
        const msg = e.message;
        toast.error(msg);
      }
    );
  getTagMeta = filepath => {
    return [];
  };
  //function call when files uploaded
  onOpenFiles = selectedPhotos => {
    const allowedExtDot = [".png", ".jpg", , ".jpeg"];
    const allowedExt = ["png", "jpg", "jpeg"];
    const isPrivate = false;
    let filepaths = selectedPhotos.target.files;
    const promises = [];
    let number = 0;
    if (filepaths.length > 0) {
      for (let i = 0; i < filepaths.length; i++) {
        var filepath = filepaths[i];
        var fileName = filepaths[i].name;
        var size = filepaths[i].size;
        let ext = path.extname(fileName);
        let filename = path.basename(fileName, ext);
        if (!allowedExtDot.includes(ext.toLowerCase())) {
          toast.error("Invalid file type");
          return;
        }

        const MAX_FILESIZE = 4 * 1000 * 1000; // 4MB
        if (size > MAX_FILESIZE) {
          toast.error(
            `The image '${filename}' is too large. Images can not be larger than 4MB.`
          );
          return;
        }
        const promise = this.onAddPhoto(filename, ext, filepath, isPrivate);
        promises.push(promise);
        number++;
      }

      if (number === 0) {
        return;
      }

      actions.wrapLoading(
        this.props,
        Promise.all(promises)
          .then(values => {
            const message =
              number === 1
                ? "Successfully Added 1 Photo"
                : `Successfully Added ${number} Photos`;
            toast.success(message);
            this.setState({ openFirst: true });
            this.loadData(this.state.mode);
          })
          .catch(e => {
            console.log(e);
          })
      );
    } else {
      toast.error("No file selected");
      return;
    }
  };

  onAddPhoto = (filename, ext, filepath, isPrivate) => {
    const rand = Math.floor(Math.random() * 90 + 10);
    const prefix = isPrivate ? "private/" : "public/";
    const photoKey = `${filename}-${rand}`;

    const image = filepath;
    let tags = this.getTagMeta(filepath);
    const full = `${prefix}${photoKey}-full${ext}`;

    const item = { image, type: "photoFull", name: full };
    const files = {}

    let uploadData = item.image;
    let s3url;

    // return API.RequestUploadFile(`${item.name}`, item.image.type)
    //   .then(res => {
    //     s3url = res.uploadFile.url.split("?")[0];
    //     console.log("data", JSON.stringify(res));
    //     return API.UploadFile(
    //       res.uploadFile.url,
    //       uploadData,
    //       uploadData.type
    //     );
    //   })
    return s3Upload(uploadData, item.name, item.image.type, false)
      .then(res => {
        // let url = s3url
        let url = res.Location
        console.log(config().NODE_ENV)
        if (config().NODE_ENV !== "development") {
          url = url.replace(
            `https://s3.${config().s3.REGION}.amazonaws.com/`,
            "https://"
          );
        }
        files.photoFull = url
        files.photoWeb = url.replace(`-full${ext}`, `-web${ext}`)
        files.thumbnail = url.replace(`-full${ext}`, `-thumb${ext}`)
        files.fileType = item.image.type
        files.fileExt = ext

        return this.addNewPhoto(photoKey, files, isPrivate, filename, tags);
      });
  };

  resizeToTarget = image => {
    const TARGET = 800 * 1000; // 800 Kb
    let iterations = 0;
    let resized = image.toJPEG(100);
    let size = resized.byteLength;
    while (size >= TARGET) {
      resized = image.toJPEG(85);
      size = resized.byteLength;
      iterations++;
      if (iterations > 5) {
        break;
      }
    }
    return resized;
  };

  addNewPhoto = (photoKey, files, isPrivate, filename, tags) =>
    API.AddPhoto(photoKey, files, isPrivate, filename, tags).then(
      result => {
        // console.log(result);
      },
      e => {
        const msg = e.message;
        toast.error(msg);
      }
    );

  onPhotoFormOpen = (item, index) => {
    this.setState({
      showPhotoForm: true,
      currentPhoto: {
        item,
        index
      },
      photoFormConfig: {
        photoId: item.photoId
      }
    });
  };

  onPhotoFormClose = () => {
    this.setState({ showPhotoForm: false });
  };

  onPhotoFormDone = () => {
    this.setState({ showPhotoForm: false });
    this.loadData(this.state.mode);
  };

  onPhotoFormDoneNext = () => {
    const { gallery } = this.props;

    if (gallery && this.state.currentPhoto.index < gallery.Items.length - 1) {
      this.onPhotoFormOpen(
        gallery.Items[this.state.currentPhoto.index + 1],
        this.state.currentPhoto.index + 1
      );
    } else {
      this.setState({ showPhotoForm: false });
      this.loadData(this.state.mode);
    }
  };

  onPhotoSelect = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    let selectedPhotos = this.state.selectedPhotos;
    if (selectedPhotos.find(x => x.photoId == item.photoId)) {
      selectedPhotos = selectedPhotos.filter(x => x.photoId != item.photoId);
    } else {
      selectedPhotos.push(item);
    }
    this.setState({ selectedPhotos });
  };

  onPhotoMultiFormOpen = () => {
    this.setState({ showPhotoMultiForm: true });
  };

  onPhotoMultiFormClose = () => {
    this.setState({ showPhotoMultiForm: false, selectedPhotos: [] });
  };

  onPhotoMultiFormDone = () => {
    this.setState({ showPhotoMultiForm: false });
    this.loadData(this.state.mode);
  };

  onCopyAttrs = attrs => {
    if (this.state.selectedPhotos.length === 1) {
      this.setState({
        copiedPhoto: this.state.selectedPhotos[0],
        copiedAttrs: attrs,
        selectedPhotos: [],
        showCopyForm: false
      });
      toast.success("Copied attributes");
    } else {
      this.setState({ showCopyForm: false });
    }
  };

  onPasteAttrs = () => {
    if (!this.state.copiedPhoto.photoId) {
      return;
    }
    const data = this.state.copiedPhoto;
    const photoIds = this.state.selectedPhotos.map(x => x.photoId);
    const attrs = this.state.copiedAttrs;
    const categories = attrs.categories ? data.categories : null;
    const subcategories = attrs.subcategories ? data.subcategories : null;
    const tags = attrs.tags ? data.tags : null;
    const photoAlt = attrs.photoAlt ? data.photoAlt : null;
    return actions.wrapLoading(
      this.props,
      API.UpdatePhotoMulti(photoIds, categories, subcategories, tags, photoAlt)
        .then(
          result => {
            toast.success("Successfully pasted attributes");
            this.loadData(this.state.mode);
            this.setState({ copiedPhoto: {} });
          },
          e => {
            const msg = e.message;
            toast.error(msg);
          }
        )
        .catch(e => {
          console.log(e);
        })
    );
  };

  updateSitemap = () =>
    actions.wrapLoading(
      this.props,
      API.GetSitemap().then(
        result =>
          s3Upload(result, "sitemap.xml", ".xml", true).then(res => {
            toast.success("Successfully updated sitemap");
          }),
        e => {
          const msg = e.message;
          toast.error(msg);
        }
      )
    );

  render() {
    if (this.state.isLogined === false) {
      // return <Redirect to="/login" />;
    }
    const { gallery } = this.props;

    return (
      <View
        style={{ height: "100%" }}
        onKeyDown={() => {
          console.log("keyprss ");
        }}
      >
        <Container>
          <Button className="tabButton" color="primary">
            Photos
          </Button>
          <Button
            className="tabButton"
            color="primary"
            outline
            onClick={() => {
              this.props.history.push("/categories");
            }}
          >
            Categories
          </Button>
          <Button
            className="tabButton"
            color="primary"
            outline
            onClick={() => {
              this.setState({ showSettingsForm: true });
            }}
          >
            Settings
          </Button>
          <span className="divider" />
          <ButtonGroup className="tabButton">
            <Button
              outline={this.state.mode !== "TAGGED"}
              onClick={() => this.setMode("TAGGED")}
            >
              Public
            </Button>
            <Button
              outline={this.state.mode === "TAGGED"}
              onClick={() => this.setMode("UNTAGGED")}
            >
              All
            </Button>
          </ButtonGroup>

          {this.state.mode === "TAGGED" ? (
            <Button
              className="tabButton"
              color="success"
              outline
              onClick={() => {
                //set click of hidden field when add photos button click
                document.getElementById("add-photos-file").click();
              }}
            >
              Add Photos
            </Button>
          ) : null}
          {/* hidden field for upload files */}
          {this.state.mode === "TAGGED" ? (
            <Input
              id="add-photos-file"
              className="filePicker"
              type="file"
              accept="image/*"
              onChange={this.onOpenFiles}
              multiple
            />
          ) : null}
          {this.state.mode === "TAGGED" ? (
            <Button
              className="tabButton"
              color="success"
              outline
              onClick={this.onPhotoMultiFormOpen}
              disabled={!this.state.selectedPhotos.length}
            >
              Multi Edit
            </Button>
          ) : null}
          {this.state.mode === "TAGGED" ? (
            <Button
              className="tabButton"
              color="success"
              outline
              onClick={this.updateSitemap}
            >
              Update Sitemap
            </Button>
          ) : null}
          {this.state.mode === "TAGGED" &&
            this.state.selectedPhotos.length === 1 ? (
            <Button
              title="Copy"
              className="tabButton"
              outline
              onClick={() => {
                this.setState({ showCopyForm: true });
              }}
            >
              <i style={{ fontSize: "20px" }} className="fa fa-copy" />
            </Button>
          ) : null}
          {this.state.mode === "TAGGED" &&
            this.state.selectedPhotos.length &&
            this.state.copiedPhoto.photoId ? (
            <Button
              title="Paste"
              className="tabButton"
              outline
              onClick={this.onPasteAttrs}
            >
              <i style={{ fontSize: "20px" }} className="fa fa-paste" />
            </Button>
          ) : null}

          <Button className="iconButton" color="link" onClick={this.onLogout}>
            <i style={{ fontSize: "20px" }} className="fa fa-external-link" />
          </Button>
        </Container>
        <ItemContainer>
          {gallery.Items &&
            gallery.Items.map((item, index) => (
              <Item
                key={item.photoId}
                className="photoItem"
                onClick={() => this.onPhotoFormOpen(item, index)}
              >
                <ImageName>
                  #{item.photoNum} - {item.photoName}
                </ImageName>
                <ImageSelect>
                  <Button
                    className="checkButton"
                    color="link"
                    onClick={e => this.onPhotoSelect(e, item)}
                  >
                    {this.state.selectedPhotos.find(
                      x => x.photoId === item.photoId
                    ) ? (
                      <i
                        style={{ fontSize: "22px", color: "#28a745" }}
                        className="fa fa-check-square-o"
                      />
                    ) : (
                      <i
                        style={{ fontSize: "22px" }}
                        className="fa fa-square-o"
                      />
                    )}
                  </Button>
                </ImageSelect>
                <ImageCategory>
                  {item.categories && item.categories.join(", ")}
                </ImageCategory>
                <ImageHolder>
                  <PhotoImage src={item.thumbnail} />
                </ImageHolder>
              </Item>
            ))}
        </ItemContainer>

        {this.state.showPhotoForm ? (
          <PhotoForm
            {...this.state.photoFormConfig}
            type={this.state.mode}
            visible={this.state.showPhotoForm}
            onClose={this.onPhotoFormClose}
            onDone={this.onPhotoFormDone}
            onDoneNext={this.onPhotoFormDoneNext}
          />
        ) : (
          ""
        )}

        {this.state.showPhotoMultiForm ? (
          <PhotoMultiForm
            selectedPhotos={this.state.selectedPhotos}
            visible={this.state.showPhotoMultiForm}
            onClose={this.onPhotoMultiFormClose}
            onDone={this.onPhotoMultiFormDone}
          />
        ) : (
          ""
        )}

        {this.state.showSettingsForm ? (
          <SettingsForm
            visible={this.state.showSettingsForm}
            onClose={() => this.setState({ showSettingsForm: false })}
            onDone={() => this.setState({ showSettingsForm: false })}
          />
        ) : (
          ""
        )}

        {this.state.showCopyForm ? (
          <CopyForm
            visible={this.state.showCopyForm}
            onClose={() => this.setState({ showCopyForm: false })}
            onDone={attrs => this.onCopyAttrs(attrs)}
          />
        ) : (
          ""
        )}
      </View>
    );
  }
}

const Container = styled.View`
  padding: 15px;
  border-bottom: 2px solid ${styled.mainColor};
  margin-left: 10px;
  margin-right: 10px;
`;

const ItemContainer = styled.View`
  padding: 10px;
  height: auto;
  overflow-y: auto;
  height: calc(100% - 70px);
`;

const Item = styled.View`
  display: inline-block;
  // height: 200px;
  width: 200px;
  background: none;
  margin: 10px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  text-align: left;
  vertical-align: top;
  background: #fbfbfb;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

const ImageHolder = styled.View`
  width: 100%;
  height: 140px;
  overflow: hidden;
  cursor: pointer;
`;

const PhotoImage = styled.Image`
  object-fit: cover;
  width: 100%;
  height: 140px;
`;

const ImageCategory = styled.Text`
  display: block;
  text-transform: uppercase;
  font-size: 11px;
  padding: 0px 12px 10px 12px;
`;
const ImageName = styled.Text`
  display: block;
  font-weight: bold;
  padding: 10px 24px 4px 12px;
  font-size: 13px;
  min-height: 52px;
`;

const ImageSelect = styled.View`
  display: block;
  position: absolute;
  top: 1px;
  right: 1px;
`;

export default compose(
  connect(
    state => ({
      gallery: state.gallery.search
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(HomePage);
